import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { FlexModule } from "@angular/flex-layout";
import { MatButtonModule } from "@angular/material/button";
import { MatDialogModule } from "@angular/material/dialog";
import { MatIconModule } from "@angular/material/icon";
import { SafeHtmlPipe } from "../pipes/safe-html.pipe";
import { GenericNotificationComponent } from "./generic-notification.component";

@NgModule({
    declarations: [GenericNotificationComponent],
    exports: [GenericNotificationComponent],
    imports: [CommonModule, MatDialogModule, FlexModule, MatIconModule, MatButtonModule, SafeHtmlPipe]
})
export class GenericNotificationModule {}
